import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { Alert } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const StyledAlert = styled(Alert)(
  {
    marginBottom: 12,
  },
  addHighContrastStyles(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
  })),
);

const ModelDeactivatedWarning = () => (
  <StyledAlert severity="warning">
    <FormattedMessage id="editor.model_editor.model_deactivated_warning" />
  </StyledAlert>
);

export default ModelDeactivatedWarning;
